import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import icons from '../../../constants/icons';
import { useTranslation } from 'react-i18next';
import type { ScopeChip } from '../types';

export interface InsightsScopeChipsProps {
  chips: ScopeChip[];
  onRemove: (scopeKey: string) => void;
  className?: string;
}

function InsightsScopeChips({
  chips,
  onRemove,
  className = 'd-flex flex-wrap mb-2',
}: InsightsScopeChipsProps) {
  const { t } = useTranslation();

  if (!chips?.length) return null;

  return (
    <div className={className}>
      {chips.map((scope) =>
        scope.removable === false ? (
          <span
            className="me-2 mb-2 px-3 py-2 border rounded d-inline-flex align-items-center"
            key={`${scope.scopeKey}-${scope.id}`}
            title={t('Context filter')}
            style={{ cursor: 'default' }}
          >
            {scope.icon && (
              <span className="icon-wrapper me-3 text-blue">
                <FontAwesomeIcon icon={scope.icon} />
              </span>
            )}
            {scope.name}
            <span className="icon-wrapper ms-3">
              <FontAwesomeIcon icon={icons.LOCKED} />
            </span>
          </span>
        ) : (
          <button
            className="btn btn-default btn-outline btn-filter me-2 mb-2"
            key={`${scope.scopeKey}-${scope.id}`}
            onClick={() => onRemove(scope.scopeKey)}
            title={t('Remove filter')}
          >
            {scope.icon && (
              <span className="icon-wrapper me-3 text-blue">
                <FontAwesomeIcon icon={scope.icon} />
              </span>
            )}
            {scope.name}
            <span className="icon-wrapper ms-3">
              <FontAwesomeIcon icon={icons.DELETE_TAG} />
            </span>
          </button>
        )
      )}
    </div>
  );
}

export default InsightsScopeChips;
